export default __webpack_public_path__ + "static/media/2019Image.879574fc.png";